var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNose4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.4 31.2",
    style: {
      enableBackground: "new 0 0 42.4 31.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.6;fill:url(#SVGID_00000169531172420736614240000005104417506968565167_);}\n\t.st2{fill:url(#SVGID_00000031894567651357995240000016586811679931678597_);}\n\t.st3{opacity:0.25;fill:url(#SVGID_00000128466094307786361870000007973010380127708316_);}\n\t.st4{fill:#4E1B3D;}\n\t.st5{opacity:0.25;fill:url(#SVGID_00000088129271996235471010000013094166085696696726_);}\n\t.st6{fill:url(#SVGID_00000127737598414046969500000003178167238011584944_);}\n\t.st7{fill:url(#SVGID_00000142174685527941180150000003112040706046162062_);}\n\t.st8{fill:url(#SVGID_00000183219929426969933800000004208742827370325166_);}\n\t.st9{opacity:0.25;fill:url(#SVGID_00000067920589169684800730000015861909747947226499_);}\n\t.st10{opacity:0.6;fill:url(#SVGID_00000168088196699773176210000010570534594617505719_);}\n\t.st11{opacity:0.6;fill:url(#SVGID_00000114782468857180344690000001463610495028399270_);}\n\t.st12{opacity:0.6;fill:url(#SVGID_00000042731328092811906450000010110751569620837293_);}\n\t.st13{opacity:0.6;fill:url(#SVGID_00000001633673212203858570000017968277552959229865_);}\n\t.st14{fill:#FFCCB8;}\n\t.st15{fill:#FFFFFF;}\n\t.st16{opacity:0.6;fill:url(#SVGID_00000057140612696094211570000008494918385366240426_);}\n\t.st17{fill:#FFCEBE;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.2262,
    y1: 7.3774,
    x2: 21.2262,
    y2: 31.89,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2816D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03990931,
    style: {
      stopColor: "#F38572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3436,
    style: {
      stopColor: "#F79E96"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#F9A7A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    style: {
      stopColor: "#FBA397",
      stopOpacity: 0.8576
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7173,
    style: {
      stopColor: "#FD9C83",
      stopOpacity: 0.5718
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8588,
    style: {
      stopColor: "#FF9777",
      stopOpacity: 0.2855
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9673",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41,21c-1.2,0.7-5.8-0.8-10.2,1.2s-6.3,2.4-9.6,2.4s-5.2-0.4-9.6-2.4S2.7,21.7,1.4,21 c-1.1-0.6-3.3-4.5,1.9-11.4c0.6-0.7,1.2-1.5,2-2.3C13-1,21.2,0,21.2,0s8.3-1,16,7.2c0.8,0.8,1.4,1.6,2,2.3 C44.4,16.4,42.1,20.4,41,21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182501767960347868320000013947836694320355746_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.01382659,
    y1: 17.1,
    x2: 42.4523,
    y2: 17.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000182501767960347868320000013947836694320355746_)"
    },
    d: "M41,21 c-1.2,0.7-5.8-0.8-10.2,1.2s-6.3,2.4-9.6,2.4s-5.2-0.4-9.6-2.4S2.7,21.7,1.4,21c-1.1-0.6-3.3-4.5,1.9-11.4c0,0-1,5.2,1.8,6.8 c0,0,8.3,1.6,16.1,1.6s16.1-1.6,16.1-1.6c2.8-1.6,1.8-6.8,1.8-6.8C44.4,16.4,42.1,20.4,41,21z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113325539083400008320000000653390974567664538_",
    gradientUnits: "userSpaceOnUse",
    x1: 6,
    y1: 23.24,
    x2: 8.8018,
    y2: 23.24,
    gradientTransform: "matrix(1 0 0 -1 0 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2AD97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1751,
    style: {
      stopColor: "#F5AC8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#F9AB80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    style: {
      stopColor: "#FAA67D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#FE9A75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9673"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113325539083400008320000000653390974567664538_)"
    },
    d: "M6,6.5c2.2-0.1,2.5,5.8,2.5,5.8 S9.6,6.8,7.6,5L6,6.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031922040186096255820000005530486715592962179_",
    gradientUnits: "userSpaceOnUse",
    x1: -7771.3335,
    y1: 23.4286,
    x2: -7768.5317,
    y2: 23.4286,
    gradientTransform: "matrix(-1 0 0 -1 -7735.0225 31.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000031922040186096255820000005530486715592962179_)"
    },
    d: "M36.3,6.3 c-2.2-0.1-2.5,5.8-2.5,5.8s-1.1-5.5,0.9-7.3L36.3,6.3z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,21.1c0,0,3.5-0.7,8.2,2C14.2,23.1,10.2,22.6,6,21.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.1,21.1c0,0-3.5-0.7-8.2,2C27.9,23.1,32,22.6,36.1,21.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056401684240208347870000008474023497319125909_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.293,
    y1: -2.2001,
    x2: 21.293,
    y2: 28.0522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000056401684240208347870000008474023497319125909_)"
    },
    d: "M21.1,0.1 c-7,0-6.7,19.8-6.7,20.4c0.2,3.6,3.6,4.8,7.1,4.6c3.3-0.2,6.6-1.5,6.7-4.5C28.3,14.4,27.4,0,21.1,0.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138551874620880585450000010337514255682632353_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9622,
    y1: 65.3873,
    x2: 8.9622,
    y2: -275.7478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2AD97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1751,
    style: {
      stopColor: "#F5AC8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    style: {
      stopColor: "#F9AB80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    style: {
      stopColor: "#FAA67D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7842,
    style: {
      stopColor: "#FE9A75"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9673"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138551874620880585450000010337514255682632353_)"
    },
    d: "M30.1-23.6c-0.4,0.9-1.6,1.7-3.2,2.4l0,0 c-1.2,0.6-2.7,1.1-4,1.5c-0.5,0.2-1,0.3-1.4,0.4c-0.3,0.1-0.6,0.2-0.8,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0-0.3,0.1 c-0.4,0.1-0.7,0.2-0.9,0.2c0,0,0,0,0,0c0,0,0,0,0,0c-0.3,0.1-0.4,0.1-0.4,0.1v0c-0.1,0.1-2.4,3.2-9.7,3.2c-7.3,0-9.6-3.1-9.7-3.2 v0c0,0-0.1,0-0.4-0.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.7-0.2c-0.2-0.1-0.4-0.1-0.6-0.2 C-3-19-3.3-19.1-3.6-19.2c-0.4-0.1-0.9-0.3-1.4-0.4c-0.2,0-0.3-0.1-0.5-0.2c-0.2-0.1-0.3-0.1-0.5-0.2c-1-0.3-2-0.7-3-1.2l0,0 c-1.6-0.7-2.8-1.6-3.2-2.4c-1.1-2.8-1.1-6.6,0.4-10c1.4-3.1,12.4-11.2,19.3-12.3c0.1,0,0.3,0,0.4-0.1c0.2,0,0.3,0,0.5-0.1 c0.1,0,0.9,0,1,0c0.8,0.1,1.7,0.2,2.6,0.5c0,0,0,0,0,0c6.9,2,16.3,9.1,17.6,11.9C31.2-30.2,31.3-26.4,30.1-23.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176034302802472157860000016903862726669977219_",
    gradientUnits: "userSpaceOnUse",
    x1: -4.6265,
    y1: -16.455,
    x2: -2.8092,
    y2: -7.3685
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176034302802472157860000016903862726669977219_)"
    },
    d: "M-1.2-18.5C-1.2-18.5-1.2-18.5-1.2-18.5 C-1.2-18.5-1.2-18.5-1.2-18.5c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.7-0.2c-0.2-0.1-0.4-0.1-0.6-0.2C-3-19-3.3-19.1-3.6-19.2 c-0.4-0.1-0.9-0.3-1.4-0.4c-0.2,0-0.3-0.1-0.5-0.2c-0.2-0.1-0.3-0.1-0.5-0.2c-1-0.3-2-0.7-3-1.2l0,0c-1.5-1.3,0-3.8,2.7-2 c1.5,1,4.1,3.5,4.9,4.3C-1.3-18.6-1.2-18.5-1.2-18.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110468306252804826790000017748894848786940606_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.7076,
    y1: -18.6226,
    x2: 24.7712,
    y2: -13.3047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#77254B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B2542"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110468306252804826790000017748894848786940606_)"
    },
    d: "M27-21.1L27-21.1c-1.2,0.6-2.7,1.1-4,1.5 c-0.5,0.2-1,0.3-1.4,0.4c-0.3,0.1-0.6,0.2-0.8,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.1,0-0.2,0-0.3,0.1c-0.4,0.1-0.7,0.2-0.9,0.2 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0.3-0.3c0.2-0.2,0.5-0.6,0.9-1c1.2-1.1,2.9-2.6,4-3.4C27-24.9,28.5-22.4,27-21.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072276855211217581080000011515513392884363153_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.4085,
    y1: -48.3304,
    x2: 9.4085,
    y2: -18.0449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB39D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    style: {
      stopColor: "#FF9B8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    style: {
      stopColor: "#FF8781"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#FF7B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7777"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000072276855211217581080000011515513392884363153_)"
    },
    d: "M9.1-46.1 c-10.2,0-9.8,19.8-9.7,20.4C-0.3-22,4.7-20.9,9.7-21c4.8-0.2,9.6-1.5,9.7-4.5C19.6-31.7,18.3-46.1,9.1-46.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170271711890237917550000001444306964020858776_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9622,
    y1: -40.7321,
    x2: 8.9622,
    y2: -15.5853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000170271711890237917550000001444306964020858776_)"
    },
    d: "M29.7-33.5 c0.8,4.7,0.1,8.5-2.1,7.7c-1.9-0.7-5.7,1.3-8.5,3.3c-0.8,0.6-7.7,2.3-10.1,2.4c-2.4-0.1-9.3-1.8-10.1-2.4c-2.7-2-6.6-4-8.5-3.3 c-2.2,0.8-2.9-3-2.1-7.7c-1.5,3.3-1.6,7.2-0.4,10c0.4,0.9,1.6,1.7,3.2,2.4l0,0c0.5,0.2,2.6,1.1,4.9,1.8c1.8,0.5,3.4,0.9,3.4,0.9v0 c0.1,0.1,2.4,3.2,9.7,3.2c0,0,0,0,0,0c0,0,0,0,0,0c7.3,0,9.6-3.1,9.7-3.2v0c0,0,1.9-0.4,4-1.1c1.8-0.6,3.8-1.4,4.3-1.6l0,0 c1.6-0.7,2.8-1.6,3.2-2.4C31.3-26.4,31.2-30.2,29.7-33.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120529502463724679030000010532445054110649022_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.709,
    y1: -34.0805,
    x2: 9.5478,
    y2: -5.6191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000120529502463724679030000010532445054110649022_)"
    },
    d: "M27.6-25.9 c-1.9-0.7-5.7,1.3-8.5,3.3c-0.8,0.6-7.7,2.3-10.1,2.4c-2.4-0.1-9.3-1.8-10.1-2.4c-2.7-2-6.6-4-8.5-3.3c-2.2,0.8-2.6,2-2.6,2.3 C-12-23.1-4.8-9.1,9-9.1s21-14.1,21.2-14.5C30.5-24.4,29.8-25,27.6-25.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005261386224373920920000007594725372519098012_",
    gradientUnits: "userSpaceOnUse",
    x1: -3.7923,
    y1: -34.2498,
    x2: -3.1765,
    y2: -24.088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000005261386224373920920000007594725372519098012_)"
    },
    d: "M-1.2-22.5 c-1.3-0.9-2.6-1.8-3.9-2.4c0,0,0.4-10-0.8-14.2C-5.9-39.2-4.2-29.9-1.2-22.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111155638532601468950000003570894768714471854_",
    gradientUnits: "userSpaceOnUse",
    x1: -4605.5625,
    y1: -34.2498,
    x2: -4604.9468,
    y2: -24.088,
    gradientTransform: "matrix(-1 0 0 1 -4583.8511 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000111155638532601468950000003570894768714471854_)"
    },
    d: "M19.1-22.5 c1.3-0.9,2.6-1.8,3.9-2.4c0,0-0.4-10,0.8-14.2C23.9-39.2,22.1-29.9,19.1-22.5z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M0.9-24.4l17.8,0.6c0,0-3.3,2.5-9.7,2.3C2.6-21.6,0.9-24.4,0.9-24.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M3.2-23.9c2.2-0.1,13.2,0.2,13.2,0.2l-6.7,1.2L3.2-23.9z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181801817127281802520000008729328332399597188_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.1378,
    y1: 12.6317,
    x2: 21.6788,
    y2: 30.9891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CE5982"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000181801817127281802520000008729328332399597188_)"
    },
    d: "M39.5,18.1 c-1.8-0.5-5.6,0.8-8.3,2.1c-0.8,0.4-7.6,1.5-10,1.5c-2.4-0.1-9.1-1.1-10-1.5c-2.7-1.3-6.5-2.6-8.3-2.1c-2.2,0.5-2.5,1.3-2.5,1.5 c0.2,0.3,7.2,9.2,20.8,9.2s20.6-8.9,20.8-9.2C42.4,19.1,41.7,18.6,39.5,18.1z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M27.2,11.2c-1.1,0.7-0.2,2.5,0.5,2.5s2.1,0,2-1.2C29.7,11.2,28.6,10.4,27.2,11.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose4);
export default __webpack_public_path__ + "static/media/Nose4.1c708763d283d4fdcb5c967e8738b359.svg";
export { ForwardRef as ReactComponent };